"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State_1 = require("./State");
function getEventType(event) {
    try {
        return typeof event === 'string' || typeof event === 'number'
            ? "" + event
            : event.type;
    }
    catch (e) {
        throw new Error('Events must be strings or objects with a string event.type property.');
    }
}
exports.getEventType = getEventType;
function toStatePath(stateId) {
    try {
        if (Array.isArray(stateId)) {
            return stateId;
        }
        return stateId.toString().split('.');
    }
    catch (e) {
        throw new Error("'" + stateId + "' is not a valid state path.");
    }
}
exports.toStatePath = toStatePath;
function toTrie(stateValue) {
    if (stateValue instanceof State_1.State) {
        return stateValue.value;
    }
    if (typeof stateValue === 'object' && !(stateValue instanceof State_1.State)) {
        return stateValue;
    }
    var statePath = toStatePath(stateValue);
    if (statePath.length === 1) {
        return statePath[0];
    }
    var value = {};
    var marker = value;
    for (var i = 0; i < statePath.length - 1; i++) {
        if (i === statePath.length - 2) {
            marker[statePath[i]] = statePath[i + 1];
        }
        else {
            marker[statePath[i]] = {};
            marker = marker[statePath[i]];
        }
    }
    return value;
}
exports.toTrie = toTrie;
function mapValues(collection, iteratee) {
    var result = {};
    Object.keys(collection).forEach(function (key) {
        result[key] = iteratee(collection[key], key, collection);
    });
    return result;
}
exports.mapValues = mapValues;



//////////////////
// WEBPACK FOOTER
// ./~/xstate/lib/utils.js
// module id = 231
// module chunks = 168707334958949